import type { GlobalState, TabState, TabArgs } from '../types';
import { getCurrentTabId } from '../../util/establishMultitabRole';

export function selectTabState<T extends GlobalState>(
  global: T,
  ...[tabId = getCurrentTabId()]: TabArgs<T>
): TabState {
  // console.log(global.byTabId[tabId]);
  return global.byTabId[tabId];
}
